module.exports = __webpack_public_path__ + "static/media/tulsa-public-schools-logo.7e043253.svg";